import { Trans } from '@lingui/react/macro';

export const NotFoundPage = () => {
  return (
    <div data-cy="404-page" className="w-full bg-neutral-light-2">
      <div className="m-auto flex max-w-screen-md flex-col items-center gap-24 px-24 py-64 md:px-64 lg:py-128">
        <h1 className="text-center heading-lg">
          <Trans>Oops!</Trans>
        </h1>
        <p className="my-0 text-center heading-sm">
          <Trans>404 - Page not found</Trans>
        </p>
        <p className="max-w-[540px] text-center">
          <Trans>
            Are you sure the website URL is correct? The page you are looking
            for might have been removed, had it&apos;s name changed or is
            temporarly unavailable.
          </Trans>
        </p>
      </div>
    </div>
  );
};
